var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        title:
          _vm.launchOrModifyType === "launch" ? "上架固件版本" : "修改上架",
        visible: _vm.launchOrModifyVisible,
        width: "628px",
        "before-close": _vm.handleClose,
        "close-on-click-modal": false,
      },
      on: {
        "update:visible": function ($event) {
          _vm.launchOrModifyVisible = $event
        },
      },
    },
    [
      _c(
        "el-form",
        {
          ref: "form",
          attrs: { rule: _vm.rules, model: _vm.form, "label-width": "160px" },
        },
        [
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "固件名称", prop: "name" } },
                    [_c("span", [_vm._v(_vm._s(_vm.form.name))])]
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "固件版本", prop: "version" } },
                    [_c("span", [_vm._v(_vm._s(_vm.form.version))])]
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "版本说明", prop: "description" } },
                    [_c("span", [_vm._v(_vm._s(_vm.form.description))])]
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "设置允许使用范围", prop: "isLaunch" } },
                    [
                      _c(
                        "el-radio-group",
                        {
                          model: {
                            value: _vm.form.allowedScope,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "allowedScope", $$v)
                            },
                            expression: "form.allowedScope",
                          },
                        },
                        [
                          _c("el-radio", { attrs: { label: 0 } }, [
                            _vm._v("不限范围"),
                          ]),
                          _c("el-radio", { attrs: { label: 1 } }, [
                            _vm._v("限定范围"),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm.form.allowedScope !== 1
                    ? _c("div", { staticClass: "desc" }, [
                        _vm.launchOrModifyType === "launch"
                          ? _c("span", [
                              _vm._v(
                                "支持所有产品ID（PID）可使用该固件版本，用于固件升级"
                              ),
                            ])
                          : _c("span", [
                              _vm._v(
                                "支持所有客户和PID可使用该固件版本，用于产品复制、OEM和固件升级"
                              ),
                            ]),
                      ])
                    : _c(
                        "div",
                        { staticClass: "table" },
                        [
                          _c(
                            "div",
                            { staticClass: "table-header" },
                            [
                              _c("div", [_vm._v("已授权范围")]),
                              _c(
                                "el-button",
                                {
                                  attrs: {
                                    type: "primary",
                                    size: "14",
                                    disabled: _vm.isLastRowEmpty,
                                  },
                                  on: { click: _vm.handleAddLine },
                                },
                                [_vm._v("添加")]
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-table",
                            {
                              staticStyle: {
                                width: "100%",
                                border: "1px solid #e6e6e6",
                              },
                              attrs: {
                                data: _vm.form.productList,
                                size: "medium",
                                border: "",
                              },
                            },
                            [
                              _c("el-table-column", {
                                attrs: {
                                  prop: "whiteListType",
                                  label: "白名单类型",
                                },
                              }),
                              _c("el-table-column", {
                                attrs: { prop: "productId", label: "产品ID" },
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "customerName",
                                  label: "客户名称",
                                },
                              }),
                              _c("el-table-column", {
                                attrs: { label: "操作", width: "100" },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c(
                                          "el-button",
                                          {
                                            attrs: { type: "text", size: "14" },
                                            on: {
                                              click: function ($event) {
                                                return _vm.handleDelete(
                                                  scope.$index
                                                )
                                              },
                                            },
                                          },
                                          [_vm._v("删除")]
                                        ),
                                      ]
                                    },
                                  },
                                ]),
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-form",
                            {
                              ref: "searchForm",
                              staticClass: "search-form",
                              attrs: { inline: true },
                            },
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 24 } },
                                [
                                  _c(
                                    "el-form-item",
                                    [
                                      _c(
                                        "el-select",
                                        {
                                          model: {
                                            value: _vm.formSearch.type,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.formSearch,
                                                "type",
                                                $$v
                                              )
                                            },
                                            expression: "formSearch.type",
                                          },
                                        },
                                        _vm._l(_vm.options, function (item) {
                                          return _c("el-option", {
                                            key: item.value,
                                            attrs: {
                                              label: item.label,
                                              value: item.value,
                                            },
                                          })
                                        }),
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-form-item",
                                    [
                                      _c("el-input", {
                                        attrs: { clearable: "" },
                                        model: {
                                          value: _vm.formSearch.productId,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.formSearch,
                                              "productId",
                                              $$v
                                            )
                                          },
                                          expression: "formSearch.productId",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-button",
                                    {
                                      attrs: {
                                        type: "primary",
                                        size: "14",
                                        disabled:
                                          !_vm.form.productList.length ||
                                          !!_vm.form.productList[
                                            _vm.form.productList.length - 1
                                          ].productId,
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.handleAddProductCheck()
                                        },
                                      },
                                    },
                                    [_vm._v("添加")]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            { attrs: { size: "14" }, on: { click: _vm.handleClose } },
            [_vm._v("取消")]
          ),
          _c(
            "el-button",
            {
              attrs: { type: "primary", size: "14" },
              on: { click: _vm.handleSubmit },
            },
            [_vm._v("确认上架")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }